import { styled } from 'styled-components'

export const Text = styled.p`
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.black};
`
